import PropTypes from 'prop-types';

export const JobSchedulePropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  display_name: PropTypes.string,
});

export const JobTypePropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  display_name: PropTypes.string,
});

export const RatingCategoryPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  is_default: PropTypes.bool,
  associated_feature_ids: PropTypes.arrayOf(PropTypes.number),
});

export const RatingCategoryListPropTypes = PropTypes.arrayOf(RatingCategoryPropTypes);

export const StationListPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  list_type: PropTypes.string,
  station_count: PropTypes.number,
});

export const StationListsPropTypes = PropTypes.arrayOf(StationListPropTypes);

export const JobPropTypes = PropTypes.shape({
  id: PropTypes.number,
  display_name: PropTypes.string,
  job_type: JobTypePropTypes,
  job_schedule: JobSchedulePropTypes,
  enabled: PropTypes.bool,
  parameters: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      ),
    ]),
  ),
  app_name: PropTypes.string,
});

export const BasicStationPropTypes = PropTypes.shape({
  id: PropTypes.number,
  retailer_reference: PropTypes.string,
  retailer_name: PropTypes.string,
});

export const BasicStationsPropTypes = PropTypes.arrayOf(BasicStationPropTypes);

export const BrandPropTypes = PropTypes.shape({
  id: PropTypes.number,
  display_name: PropTypes.string,
  image_url: PropTypes.string,
});
